// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mongosh-password-prompt-password-prompt__1910n {\n  padding-left: 23px;\n}\n.mongosh-password-prompt-password-prompt__1910n input {\n  font-family: Menlo, Monaco, 'Courier New', monospace;\n  font-size: 13px;\n  line-height: 24px;\n  background-color: #21313c;\n  color: #f9fbfa;\n  padding: 0 3px;\n  border: 1px solid #f9fbfa;\n  border-radius: 3px;\n}\n", ""]);
// Exports
exports.locals = {
	"password-prompt": "mongosh-password-prompt-password-prompt__1910n"
};
module.exports = exports;
